/*
 * @Author: Teemo Ding
 * @Date: 2021-10-26 16:15:20
 * @LastEditTime: 2021-10-26 17:09:42
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/WarehouseLocations/ParcelLocker/ParcelLockerName/index.tsx
 */
import { Input, Label } from '@/src/components/Antd';
import { replaceI18nVariables } from '@/src/tools/tools';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const DeliveryMethodName = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={css.itemBlock}>
      <div className={css.header}>
        <div className={css.title}>
          {getI18n('storeLogistics.warehouseLocations.parcelLockerName')}
        </div>
      </div>
      <div className={`${css.itemContent} ${css.content}`}>
        <Form.Item
          name='name'
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('storeLogistics.warehouseLocations.parcelLockerName'),
              ),
            },
          ]}
          className={css.deliveryMethodName}
          label={
            <Label
              title={`${getI18n(
                'storeLogistics.warehouseLocations.parcelLockerName',
              )}*`}
              rightSubTitle={getI18n(
                'storeLogistics.warehouseLocations.forinternalreference',
              )}
              textLength={100}
              nameKey='name'
            />
          }>
          <Input size='large' maxLength={100} />
        </Form.Item>
      </div>
    </div>
  );
};
export default DeliveryMethodName;
